module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.6754/img/asset-marketplace-themes-1x.png"